import { FaRobot } from "react-icons/fa";
import ChatButton from "../ChatButton";
import { useNewAgent } from "../../contexts/NewAgentContext";
import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { AgentStatus, AGENT_TYPES } from "constants/agents";
import { useTranslation } from "hooks/useTranslation";

const Finish = () => {
  const { formData, progress, agentStatus, isAgentReady, newAgentId } =
    useNewAgent();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (agentStatus === AgentStatus.ERROR) {
      // Error toast is already shown by handleAxiosAndCaughtError in NewAgentContext
      // Navigate back immediately when API creation fails
      navigate("/dashboard/agents");
    }
  }, [agentStatus, navigate]);

  return (
    <div className="flex h-full w-full flex-col items-center justify-center px-3 pt-7 md:px-8">
      <div className="mb-6">
        <FaRobot className="mx-auto text-[48px] text-brandLinear" />
      </div>

      {/* Title */}
      <h2 className="text-violet-800 mb-2 text-center text-lg font-semibold">
        {t('agents.newAgent.deployingAIAgent')} {formData.name}
      </h2>
      {newAgentId && (
        <p className="mb-2 text-center text-sm text-gray-500">{t('agents.newAgent.agentId')} {newAgentId}</p>
      )}

      {/* Progress bar */}
      <div className="mb-4 w-full max-w-md">
        <div className="h-4 w-full overflow-hidden rounded bg-gray-200 dark:bg-gray-700">
          <div
            className={`h-4 rounded transition-all duration-500 ${
              agentStatus === AgentStatus.ERROR
                ? "bg-red-500"
                : "bg-brand-600"
            }`}
            style={{ width: `${progress}%` }}
          />
        </div>
        <div className="mt-2 text-center text-sm text-gray-700 dark:text-gray-200">
          {agentStatus === AgentStatus.READY
            ? t('agents.newAgent.agentIsReady')
            : agentStatus === AgentStatus.ERROR
            ? t('agents.newAgent.agentTrainingFailed')
            : t('agents.newAgent.training', { percentage: Math.floor(progress) })}
        </div>
      </div>

      {formData.agent_type === AGENT_TYPES.AUTONOMOUS ? (
        <Link
          to="/dashboard/agents"
          className="rounded-lg bg-brand-900 px-6 py-2 text-center text-sm font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:text-gray-900 dark:hover:bg-brand-300"
        >
          {t('agents.newAgent.backToList')}
        </Link>
      ) : (
        <ChatButton isDisabled={!isAgentReady} />
      )}
    </div>
  );
};

export default Finish;
